<template>
  <div
    :class="['ui-badge', size]"
    :style="containerStyle"
    v-if="text || loading"
  >
    <ui-loader
      v-if="loading"
      size="14"
      stroke="6"
    />
    <template v-else>
      {{ text }}
    </template>

    <div
      class="fade"
      :style="fadeBackground"
      v-if="hasFade"
    />
  </div>
</template>

<script>
export default {
  name: 'ui-badge',

  props: {
    text: {
      type: [String, Number],
      default: ''
    },
    loading: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: '',
    },
    maxWidth: {
      type: String,
      default: ''
    },
  },

  data: () => ({
    focused: false,
  }),

  computed: {
    containerStyle() {
      const style = {};
      if (this.color) style.backgroundColor = this.color;
      if (this.maxWidth) style.maxWidth = `${this.maxWidth}px`;
      return style;
    },
    hasFade() {
      return !!this.maxWidth;
    },
    fadeBackground() {
      const hexToRGB = (hex) => {
        const r = parseInt(hex.slice(1, 3), 16),
          g = parseInt(hex.slice(3, 5), 16),
          b = parseInt(hex.slice(5, 7), 16);

        return "rgb(" + r + ", " + g + ", " + b + ", 1)";
      }

      return {
        background: `linear-gradient(90deg, rgba(255,255,255,0) 0%, ${hexToRGB(this.color)} 60%)`,
        left: `${this.maxWidth}px`,
      }
    }
  },

};
</script>

<style lang="scss">
.ui-badge {
  display: inline-block;
  background: $blue;
  padding: 3px 7px 0;
  min-width: 20px;
  height: 20px;
  border-radius: 10px;
  font-size: 11px;
  line-height: 16px;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  color: $white;
  overflow: hidden;
  position: relative;

  &.large {
    min-width: 24px;
    height: 24px;
    border-radius: 12px;
    font-weight: 600;
    padding: 4px 8px 0;
    font-size: 14px;
    line-height: 18px;
  }

  & .fade {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 15px;
    margin-left: -15px;
  }
}
</style>
